'use client';

import { useCallback, useLayoutEffect } from 'react';

import { useThemeSnapshot } from './use-theme-snapshot';

/** Shared by the root provider and the platform's settings-synced provider. */
export const useLocalTheme = () => {
	const { theme, resolvedTheme, ready, setTheme } = useThemeSnapshot();

	useLayoutEffect(() => {
		// Preserve the pre-paint bootstrap's class until the browser preference
		// is available; the SSR fallback must never repaint a stored light theme.
		if (!ready) return;
		document.documentElement.classList.toggle('dark', resolvedTheme === 'dark');
		document.body.classList.remove('dark');
		let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]:not([media])');
		if (!meta) {
			meta = document.createElement('meta');
			meta.setAttribute('name', 'theme-color');
			document.head.appendChild(meta);
		}
		meta.setAttribute('content', resolvedTheme === 'dark' ? '#0D0E0F' : '#ffffff');
	}, [ready, resolvedTheme]);

	const toggleTheme = useCallback(() => {
		setTheme(resolvedTheme === 'light' ? 'dark' : 'light');
	}, [resolvedTheme, setTheme]);

	return { theme, resolvedTheme, toggleTheme, setTheme };
};
